'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';

import { useEffect } from 'react';
import { useState } from 'react';
import { Pagination } from 'react-bootstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PlutoMenu from './PlutoMenu';
import PaginationPluto from './Pagination';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

function PlutoOffersFastComp() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [minutes, setMinutes] = useState(100)
    const [rank, setRank] = useState(0)
    const [condition, setCondition] = useState(0)
    const [conditionReason, setConditionReason] = useState('')
    const [alert, setAlert] = useState({ show: false, name: '', minutes: '', code: '', pin: '', id: -1, req_hold: 0.4 })
    const [alert2, setAlert2] = useState({ show: false, name: '', minutes: '', code: '', pin: 0 })

    useEffect(() => {
        socket.on('response_get_admin_offers_fast_c', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)

        })
        socket.emit('getOffersAdminFastC', {
            offers_like: username,
            page,
        })
    }, [])
    useEffect(() => {
        socket.on('reTakeSpeedyData', () => {
            socket.emit('getOffersAdminFastC', {
                offers_like: username,
                page,
            })
        })
    }, [])

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <SweetAlert
                show={alert2.show}
                onConfirm={function () {
                    socket.emit('adminAction', {
                        action: 'delete_speedy_offer',
                        id: alert.id
                    })
                    setAlert2({ show: false })
                    setAlert({ show: false, name: '', minutes: '', code: '', pin: '', id: -1 })
                }}
                style={{ backgroundColor: '#161b22', color: '#e6edf3', border: '1px solid #30363d' }}
                cancelBtnText="Not now"
                confirmBtnText="Delete"
                showCancel={true}
                cancelBtnStyle={{ color: '#8b949e', textDecoration: 'none', background: '#21262d', border: '1px solid #30363d', borderRadius: '8px', padding: '6px 16px' }}
                confirmBtnStyle={{ border: '1px solid #f85149', boxShadow: 'none', padding: '6px 16px', backgroundColor: '#da3633', borderRadius: '8px', color: '#ffffff' }}
                onCancel={function () { setAlert2({ show: false }) }}
            >
                <>
                    <h3 style={{ color: '#e6edf3' }}>Are you sure that you want to delete {alert.name}#{alert.id}?</h3>
                </>

            </SweetAlert>
            <SweetAlert
                show={alert.show}
                title={alert.title}
                onConfirm={function () {
                    if (alert.name.split("").length > 2 && parseInt(alert.minutes) > 0) {
                        if (alert.type == "add") {
                            socket.emit('adminAction', {
                                action: 'add_speedy_offer',
                                name: alert.name,
                                minutes: alert.minutes,
                                condition_action: alert.minutes,
                            })
                            setAlert({ ...alert, show: false })
                        } else if (alert.type == "edit") {
                            socket.emit('adminAction', {
                                action: 'edit_speedy_offer',
                                id: alert.id,
                                name: alert.name,
                                condition_action: alert.minutes,
                            })
                            setAlert({ ...alert, show: false })
                        }
                    }
                }}
                style={{ backgroundColor: '#161b22', color: '#e6edf3', border: '1px solid #30363d' }}
                cancelBtnText="Not now"
                confirmBtnText="Proceed"
                showCancel={true}
                cancelBtnStyle={{ color: '#8b949e', textDecoration: 'none', background: '#21262d', border: '1px solid #30363d', borderRadius: '8px', padding: '6px 16px' }}
                confirmBtnStyle={{ border: '1px solid #2ea043', boxShadow: 'none', padding: '6px 16px', backgroundColor: '#238636', borderRadius: '8px', color: '#ffffff' }}
                onCancel={function () { setAlert({ show: false, type: '', flagReason: '', code: '', pin: '', id: -1 }) }}
            >
                <>
                    <h3 style={{ color: '#e6edf3' }}>Add New Speedy Offer:</h3>
                    <input className="form-control" style={{
                        marginBottom: '10px',
                        color: '#e6edf3',
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none'
                    }} defaultValue={alert.name || ""} placeholder={alert.name || "Offer Name"} type="text" onKeyUp={(e) => {
                        setAlert({ ...alert, name: e.target.value.toLowerCase() })
                    }}></input>
                    <p style={{ color: '#c9d1d9' }}>Name: {alert.name}</p>

                    <p style={{ color: '#c9d1d9' }}>Minutes: {alert.minutes}</p>
                    <input className="form-control" style={{
                        marginBottom: '10px',
                        color: '#e6edf3',
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none'
                    }} defaultValue={alert.minutes} type="number" onChange={(e) => {
                        setAlert({ ...alert, minutes: e.target.value.toLowerCase() })

                    }} onKeyUp={(e) => {
                        setAlert({ ...alert, minutes: e.target.value.toLowerCase() })
                    }}></input>

                    {alert.type == "edit" ? <div onClick={() => {
                        setAlert({ ...alert, show: false });
                        setAlert2({ ...alert, show: true });

                    }} style={{ margin: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{
                        width: '200px',
                        cursor: 'pointer',
                        background: '#da3633',
                        color: '#ffffff',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        textAlign: 'center',
                        fontWeight: 500,
                        border: '1px solid #f85149'
                    }}>Delete</div></div> : ''}
                </>

            </SweetAlert>

            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>
                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #a855f7',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'inline-block',
                            minWidth: '160px'
                        }}>
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#e6edf3',
                                margin: 0,
                                marginBottom: '4px'
                            }}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={{
                                color: '#8b949e',
                                fontSize: '11px',
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                margin: 0
                            }}>Count offers</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Main Table Card */}
                <div style={{
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    {/* Card Header */}
                    <div style={{
                        padding: '16px 20px',
                        borderBottom: '1px solid #21262d'
                    }}>
                        <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', margin: 0, marginBottom: '6px' }}>Speedy Offers</p>
                        <p style={{ color: '#8b949e', fontWeight: 500, fontSize: '12px', margin: 0, marginBottom: '12px' }}>Please be aware that offers made under the mentioned minutes and name are to be banned with the following reason: 'Speedy Offers [n-001]'</p>
                        <div onClick={() => {
                            setAlert({ ...alert, show: true, type: 'add', id: -1 })
                        }} style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '6px 16px',
                            background: '#238636',
                            border: '1px solid #2ea043',
                            borderRadius: '8px',
                            color: '#ffffff',
                            fontSize: '12px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            transition: 'background 0.2s'
                        }}
                            onMouseEnter={(e) => e.target.style.background = '#2ea043'}
                            onMouseLeave={(e) => e.target.style.background = '#238636'}
                        >Add new</div>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ background: '#161b22' }}>
                                    <th style={{ width: '250px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Name</th>
                                    <th style={{ width: '200px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Minutes</th>
                                    <th style={{ width: '100px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {earnings.map((earning, i) => {
                                    return (
                                        <tr
                                            key={earning.id || i}
                                            style={{
                                                borderBottom: '1px solid #21262d',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#1c2128'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <td style={{ width: '250px', textAlign: 'left', color: '#e6edf3', padding: '14px 16px', fontSize: '13px' }}>{earning.name || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ width: '200px', color: '#c9d1d9', padding: '14px 16px', fontSize: '13px' }}>{earning.minutes || <Skeleton style={{ width: '30px' }} />}</td>

                                            <td style={{ padding: '14px 16px' }}>
                                                <div onClick={() => {
                                                    setAlert({ ...alert, name: earning.name, minutes: earning.minutes, show: true, type: 'edit', id: earning.id })
                                                }} style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 12px',
                                                    background: '#21262d',
                                                    border: '1px solid #30363d',
                                                    borderRadius: '8px',
                                                    color: '#e6edf3',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    cursor: 'pointer',
                                                    transition: 'background 0.2s',
                                                    minWidth: '80px',
                                                    maxWidth: '100px'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.background = '#30363d'}
                                                    onMouseLeave={(e) => e.target.style.background = '#21262d'}
                                                >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Edit'}</div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div style={{ marginBottom: '16px' }}>
                    {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0])
                        socket.emit('getOffersAdminFastC', {
                            offers_like: username,
                            minutes,
                            page,
                        })
                    }} />}
                </div>

                {/* Jump to Page */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                    <input onKeyDown={
                        (e) => {
                            if (e.key == 'Enter') {
                                canUsePagination(false)
                                setEarnings([0, 0, 0, 0, 0])
                                socket.emit('getOffersAdminFastC', {
                                    offers_like: username,
                                    minutes, page: document.getElementById('jumptotoday2fastc').value,
                                })
                            }
                        }
                    } type="number" id="jumptotoday2fastc" style={{
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        borderRadius: '8px',
                        color: '#e6edf3',
                        padding: '8px 12px',
                        fontSize: '13px',
                        outline: 'none',
                        width: '80px'
                    }}
                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                    />
                    <button onClick={() => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0])
                        socket.emit('getOffersAdminFastC', {
                            offers_like: username,
                            minutes, page: document.getElementById('jumptotoday2fastc').value,
                        })
                    }
                    } style={{
                        color: '#ffffff',
                        background: '#238636',
                        border: '1px solid #2ea043',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                    }}
                        onMouseEnter={(e) => e.target.style.background = '#2ea043'}
                        onMouseLeave={(e) => e.target.style.background = '#238636'}
                    >Go to page</button>
                </div>
            </div>
        </SkeletonTheme>
    )
}

export default PlutoOffersFastComp
